module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("SEO Title")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.seoTitle),
      expression: "value.seoTitle"
    }],
    attrs: {
      "type": "text",
      "placeholder": "SEO Title",
      "disabled": _vm.value.disable
    },
    domProps: {
      "value": (_vm.value.seoTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "seoTitle", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("SEO Description")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.seoDescription),
      expression: "value.seoDescription"
    }],
    attrs: {
      "type": "text",
      "placeholder": "SEO Description",
      "disabled": _vm.value.disable
    },
    domProps: {
      "value": (_vm.value.seoDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "seoDescription", $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-211254a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/seoTagInput.vue
// module id = 631
// module chunks = 1